module.exports = __webpack_public_path__ + "static/img/zgrb.d856ead2.png";